import { FormattedMessage } from 'react-intl';

import {
  StyledWrapper,
  StyledZoomInButton,
  StyledZoomOutButton,
  StyledBar,
  StyledStepMarkers,
  StyledStepMarker,
  StyledStepsBarBackground,
  StyledStepsBarCurrent,
} from './template-zoom.styled';

type TemplateZoomProps = {
  onZoomIn: () => void;
  onZoomOut: () => void;
  zoom: number;
};

export const TemplateZoom: React.FC<TemplateZoomProps> = ({
  onZoomIn,
  onZoomOut,
  zoom,
}) => {
  const zoomOffset = Math.floor((100 / 6) * zoom);

  return (
    <StyledWrapper>
      <StyledZoomOutButton onClick={onZoomOut} size="medium">
        <FormattedMessage id="CRATE_LEBENSLAUF_COVER_LETTER_ZOOM_OUT" />
      </StyledZoomOutButton>
      <StyledZoomInButton onClick={onZoomIn} size="medium">
        <FormattedMessage id="CRATE_LEBENSLAUF_COVER_LETTER_ZOOM_IN" />
      </StyledZoomInButton>
      <StyledStepsBarBackground />
      <StyledStepsBarCurrent $zoomOffset={zoomOffset} />
      <StyledStepMarkers>
        <StyledStepMarker />
        <StyledStepMarker />
        <StyledStepMarker />
        <StyledStepMarker />
        <StyledStepMarker />
        <StyledStepMarker />
        <StyledStepMarker />
      </StyledStepMarkers>
      <StyledBar
        type="range"
        value={zoom}
        step="1"
        min="0"
        max="6"
        onChange={(event) => {
          const value = Number(event.target.value);

          if (value > zoom) {
            onZoomIn();
          } else if (value < zoom) {
            onZoomOut();
          }
        }}
      />
    </StyledWrapper>
  );
};
